import React from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import lightLogo from "../../../../img/logo-light.png";
import thumbnail from "../../../../img/bcg_logo.png";
import SelectionTabs from "../delivery-selection-tabs";
import SelectionContent from "../delivery-tab-content";

import "./style.scss";

const Index = () => {
  return (
    <section className="delivery-page-section">
      <div className="inner-delivery-page-container">
        <div className="full-content-container">
          <div className="delivery-display-container">
            <div className="delivery-box-container">
              <div className="inner-delivery-box-container">
                <div className="logo-container">
                  <img alt="Levering" src={lightLogo} className="logo" />
                </div>
                <div className="upper-container">
                  <Row className="upper-row">
                    <Col className="thumbnail-col">
                      <img
                        alt="Levering"
                        className="delivery-thumbnail"
                        src={thumbnail}
                      />
                    </Col>
                    <Col className="summary-col my-auto">
                      <h2 className="delivery-title">
                        Wordpress nettside med SEO
                      </h2>
                      <p className="delivery-involved">
                        Levering fra Leadfind AS
                      </p>
                    </Col>
                    <Col className="button-col text-right my-auto">
                      <button className="select-button">
                        <i class="fad fa-ellipsis-h"></i>
                      </button>
                    </Col>
                  </Row>
                </div>
                <div className="details-container">
                  <Row className="details-row">
                    <Col className="price-col">
                      <label>Beløp</label>
                      <h3 className="amount">
                        <span className="nok">NOK</span> 10 000 kr
                      </h3>
                    </Col>
                    <Col className="start-col">
                      <label>Startdato</label>
                      <span className="date start">10/10/2021</span>
                    </Col>
                    <Col className="end-col">
                      <label>Leveringsdato</label>
                      <span className="date end">10/10/2021</span>
                    </Col>
                    <Col className="end-col">
                      <label>Progresjon</label>
                      <div className="progress-container">
                        <div
                          className="progress"
                          style={{ display: 25 > 0 ? "flex" : "none" }}
                        >
                          <div
                            className="progress-bar"
                            role="progressbar"
                            style={{ width: 25 + "%" }}
                            aria-valuenow="25"
                            aria-valuemin="0"
                            aria-valuemax="100"
                          ></div>
                        </div>
                        <span className="percentage">25%</span>
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="description-container">
                  <p className="delivery-information">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Mauris sit amet congue odio. Integer semper mollis
                    scelerisque. Praesent rhoncus fringilla eros, eget sodales
                    purus vehicula ut. Morbi velit quam, placerat eget molestie
                    et, facilisis ac justo. Nunc commodo, arcu vel vulputate
                    accumsan, risus dolor egestas purus, et sollicitudin dolor
                    diam sit amet ante.
                  </p>
                </div>
                <div className="content-container">
                  <SelectionTabs />
                  <SelectionContent />
                </div>
              </div>
            </div>
            <div className="links-container">
              <Link to="/">Leadfind.no</Link>
              <span className="circle-separator">
                <i class="fas fa-circle"></i>
              </span>
              <Link to="/personvern">Personvern</Link>
              <span className="circle-separator">
                <i class="fas fa-circle"></i>
              </span>
              <Link to="/cookies">Cookies</Link>
              <span className="circle-separator">
                <i class="fas fa-circle"></i>
              </span>
              <Link to="/vilkår">Vilkår</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Index;
